import { AutogenLayoutOfficePendingPayAdjustmentList } from "./autogen/AutogenLayoutOfficePendingPayAdjustmentList";

export class OfficePendingPayAdjustmentList extends AutogenLayoutOfficePendingPayAdjustmentList {
    onLoad(): void | Promise<void> {
        this.mainDataSource.orderBy = [
            { field: "payee_id", sort: "asc" },
            { field: "deduction_type", sort: "asc" },
            { field: "deduct_code_short_desc", sort: "asc" }
        ];
    }
}
